import { ExpandMore } from '@material-ui/icons';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Divider,
} from '@material-ui/core';
import { useState } from 'react';
import { observer } from 'mobx-react';
import { TitleDivider } from '../../../components/titleDivider';
import { FeesDetailsTable } from '../../../components/feesDetailsTable';
import { QuoteTypeStore } from '../../../stores/quoteTypeStore';
import { LoanSubType } from '@roc/feature-utils';
import { FeesDetailsTableTerm } from '../../../components/feesDetailsTableTerm';

interface PointsAndFeesDetailsAccordionProps {
  store: QuoteTypeStore;
}

export const PointsAndFeesDetailsAccordion = observer(
  ({ store }: PointsAndFeesDetailsAccordionProps) => {
    const [expanded, setExpanded] = useState(false);
    const isSinglePropertyRental = store.loanSubtype === LoanSubType.SINGLE_PROPERTY;
    const isRentalPortfolio = store.loanSubtype === LoanSubType.RENTAL_PORTFOLIO;
    const isTermLoan = isSinglePropertyRental || isRentalPortfolio
    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}
        elevation={0}
      >
        <AccordionSummary
          expandIcon={<ExpandMore fontSize="large" />}
          aria-controls={`economics-summary-accordion`}
        >
          <Grid item xs={12}>
            <TitleDivider title={isTermLoan ? "Points & Fee Details" : "Borrower Cash to Close"} />
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {isTermLoan ? <FeesDetailsTableTerm store={store} /> : <FeesDetailsTable store={store} />}
        </AccordionDetails>
      </Accordion>
    );
  }
);
